import * as React from 'react';
import { Layout, Row, Col, Card } from 'antd';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import {
	invoicesRestCrudThunksForSupplier,
	publishInvoiceForSupplier,
} from '../../thunks/invoices_thunks';
import InvoiceUploader from '../invoice_uploader/InvoiceUploader';
import {
	appendWorkOrderNotesForSupplier,
	workOrdersRestCrudThunksForSupplier,
} from '../../thunks/work_orders_thunks';
import { markUserNotificationsReadForSupplier } from '../../thunks/user_notifications_thunks';
import { getEntityById, nullSafeGet } from '../../utils/DataAccessUtils';
import SupplierInvoiceDetailDetailsPageWrapper from '../supplier_invoice_detail_details_page_wrapper/SupplierInvoiceDetailDetailsPageWrapper';
import {
	getInvoiceRestCrudThunksFromPath,
	isClientInvoiceView,
} from '../invoice_utilities/InvoiceUtilities';
import { getSanitisedWorkOrder } from '../../utils/WorkOrderUtils';
import GenerateInvoicePdfButton from '../invoices_detail_details_page/GenerateInvoicePdfButton';
import { withUserType } from '../withUserType';

const { Content } = Layout;

const style = require('./SupplierInvoicesDetailDetailsPage.less');

class InvoicesDetailPage extends React.Component<any, any> {
	constructor(props) {
		super(props);
		this.state = {
			generatingPDF: false,
			pdfFile: { url: null, httpHeaders: null },
			buttonLoading: false,
		};
	}

	componentDidMount() {
		const { getInvoice, match, markUserNotificationsRead, invoice, getWorkOrder } = this.props;
		const invoiceId = match.params.id;
		if (invoice && invoice.id) {
			markUserNotificationsRead(invoiceId);
			getWorkOrder(invoice.workOrder.id);
		} else {
			getInvoice(invoiceId).then(() => markUserNotificationsRead(invoiceId));
		}
	}
	componentDidUpdate(prevProps) {
		const { invoice, markUserNotificationsRead, getWorkOrder } = this.props;
		const { invoice: prevInvoice } = prevProps;
		if (invoice && prevInvoice && invoice.id !== prevInvoice.id) {
			markUserNotificationsRead(invoice.id);
			if (invoice.workOrder && invoice.workOrder.id) {
				getWorkOrder(invoice.workOrder.id);
			}
		}
	}

	refreshInvoice = () => {
		const { getWorkOrder, getInvoice, match } = this.props;
		const invoiceId = match.params.id;
		return getInvoice(invoiceId).then((invoice) => {
			getWorkOrder(nullSafeGet('workOrder.id', invoice));
			return invoice;
		});
	};

	handleFileAttachmentUploadChange = (newAttachments) => {
		const { updateInvoice, invoice } = this.props;
		const newInvoice = {
			...invoice,
			attachments: newAttachments,
		};
		updateInvoice(newInvoice);
	};

	handleInvoicePDFUploadChangeForDeletedInvoice = (invoiceFileUrl) => {
		const { updateInvoice, getInvoice, invoice } = this.props;

		const newInvoice = {
			...invoice,
			invoicePDFLink: invoiceFileUrl,
			isDeleted: false,
		};

		updateInvoice(newInvoice).then(() => {
			getInvoice(invoice.id);
		});
	};

	render() {
		const { invoice, history, invoicesUpdating, invoicesFetching, currentUser } = this.props;

		if (invoicesFetching) return null;
		if (invoice.isDeleted) {
			return (
				<Row gutter={12}>
					<Col span={24}>
						<Card>
							<div>
								<h5 style={{ marginBottom: '4px' }}>Upload an invoice file</h5>
								<div>
									<p
										style={{
											fontSize: 16,
											marginBottom: '0.5em',
										}}
									>
										Add an invoice file (PDF) to finish creating the invoice.
									</p>
									<InvoiceUploader
										roleType="supplier"
										invoiceId={invoice.id}
										buttonType="primary"
										defaultFileList={[]}
										multiple={false}
										handleUploadSuccess={this.handleInvoicePDFUploadChangeForDeletedInvoice}
										invoice={invoice}
									/>
									<GenerateInvoicePdfButton invoice={invoice} />
								</div>
							</div>
						</Card>
					</Col>
				</Row>
			);
		}

		return (
			<Content className="invoicesDetailDetailsPage" key={nullSafeGet('id', invoice)}>
				<SupplierInvoiceDetailDetailsPageWrapper
					invoice={invoice}
					invoicesUpdating={invoicesUpdating}
					refreshInvoice={this.refreshInvoice}
					workOrder={getSanitisedWorkOrder(invoice.workOrder)}
					showViewInvoicePage={false}
					isClientView={isClientInvoiceView(invoice, currentUser)}
				/>
			</Content>
		);
	}
}

const mapStateToProps = (state, ownProps) => ({
	invoicesFetching: state.invoices.fetching,
	invoice: getEntityById(ownProps.match.params.id, state.invoices),
	invoicesCreating: state.invoices.creating,
	invoicesUpdating: state.invoices.updating,
	currentUser: state.session.currentUser,
	match: ownProps.match,
	history: ownProps.history,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
	appendWorkOrderNotes: (entity) => dispatch(appendWorkOrderNotesForSupplier(entity)),
	getInvoice: (id) =>
		dispatch(
			getInvoiceRestCrudThunksFromPath(ownProps.userType, ownProps.history.location).readOne(id)
		),
	getWorkOrder: (id) => dispatch(workOrdersRestCrudThunksForSupplier.readOne(id)),
	updateInvoice: (entity) =>
		dispatch(
			getInvoiceRestCrudThunksFromPath(ownProps.userType, ownProps.history.location).update(entity)
		),
	publishInvoice: (id) => dispatch(publishInvoiceForSupplier({ id })),
	markUserNotificationsRead: (entityId) =>
		dispatch(markUserNotificationsReadForSupplier('Invoice', entityId)),
});

export default withUserType(connect(mapStateToProps, mapDispatchToProps)(InvoicesDetailPage));
